import { Link } from 'react-router-dom';
import { navCategories } from '@/mocks/navigation';

export default function HeroSection() {
  return (
    <section className="relative min-h-[90vh] flex items-center overflow-hidden bg-foreground-900">
      <img
        src="https://readdy.ai/api/search-image?query=Abstract%20digital%20landscape%20with%20flowing%20neon%20lines%20in%20warm%20amber%20and%20coral%20tones%20on%20dark%20backdrop%2C%20modern%20tech%20aesthetic%2C%20geometric%20patterns%20with%20glowing%20nodes%2C%20futuristic%20navigation%20concept%2C%20minimal%20composition%2C%20soft%20gradient%20atmosphere%2C%20dark%20background%20with%20vibrant%20accent%20colors%20contrasting%20with%20light%20text%20areas&width=1800&height=1200&seq=hero-bg-51nav-v2&orientation=landscape"
        alt="51网址导航 - 网址导航大全"
        className="absolute inset-0 w-full h-full object-cover object-top z-0"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/50 z-[1]"></div>

      <div className="relative z-10 w-full">
        <div className="max-w-7xl mx-auto px-4 md:px-6">
          <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-0">
            <div className="lg:w-1/2 flex flex-col items-start pt-20 lg:pt-0">
              <h1 className="font-heading font-bold text-4xl sm:text-5xl md:text-6xl text-white leading-tight tracking-tight">
                汇集全网精华
                <br />
                <span className="text-accent-400">导航精彩世界</span>
              </h1>
              <p className="mt-6 text-white/80 text-base md:text-lg leading-relaxed max-w-md">
                51网址导航收录<strong className="text-white">百万网址</strong>，覆盖九大核心分类。每日更新<strong className="text-white">吃瓜爆料</strong>、
                <strong className="text-white">网红黑料</strong>与<strong className="text-white">明星塌房</strong>现场，一站式满足你的网址导航与娱乐八卦需求。
              </p>
              <div className="mt-8 flex items-center gap-4">
                <Link
                  to="/category/yingshi"
                  className="whitespace-nowrap px-6 py-3 rounded-full bg-accent-500 text-white font-label font-semibold text-sm hover:bg-accent-600 transition-colors cursor-pointer"
                >
                  开始导航
                </Link>
                <Link
                  to="/article/chigua-2026-0706"
                  className="whitespace-nowrap px-6 py-3 rounded-full border border-white/30 text-white font-label font-medium text-sm hover:bg-white/10 transition-colors cursor-pointer flex items-center gap-2"
                >
                  吃瓜爆料
                  <i className="ri-arrow-right-line"></i>
                </Link>
              </div>

              <div className="mt-12 flex items-center gap-6 flex-wrap">
                {navCategories.slice(0, 4).map((cat) => (
                  <Link
                    key={cat.id}
                    to={`/category/${cat.slug}`}
                    className="flex items-center gap-2 text-white/60 hover:text-white transition-colors cursor-pointer"
                  >
                    <div className="w-8 h-8 rounded-lg bg-white/10 flex items-center justify-center">
                      <i className={`${cat.icon} text-sm text-accent-400`}></i>
                    </div>
                    <span className="text-xs font-label font-medium whitespace-nowrap">{cat.name}</span>
                  </Link>
                ))}
              </div>
            </div>

            <div className="lg:w-1/2 flex justify-center lg:justify-end">
              <div className="relative w-full max-w-md">
                <div className="bg-white/10 backdrop-blur-md rounded-2xl p-6 border border-white/10">
                  <div className="flex items-center gap-2 mb-5">
                    <i className="ri-fire-line text-accent-400 text-lg"></i>
                    <span className="text-white font-label font-semibold text-sm">今日热搜</span>
                  </div>
                  <div className="space-y-3">
                    {['某顶流男星深夜密会神秘女子', '网红直播间假货当场鉴定', '模范夫妻突然宣布离婚', '知名艺人涉嫌偷税漏税', '网红城市打卡地被曝宰客'].map((item, i) => (
                      <Link
                        key={i}
                        to={`/article/chigua-2026-070${i + 1}`}
                        className="flex items-center gap-3 text-white/70 hover:text-accent-400 transition-colors cursor-pointer group"
                      >
                        <span className="font-label font-bold text-xs w-5 text-accent-400">
                          {String(i + 1).padStart(2, '0')}
                        </span>
                        <span className="text-sm flex-1 group-hover:underline underline-offset-4">{item}</span>
                        <span className="text-xs px-2 py-0.5 rounded-full bg-primary-500/80 text-white font-label">热</span>
                      </Link>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}